import * as Tokens from '../utils/DesignTokens/theme/lhub/tokens';
import prepareTheme from './prepareTheme';
const CompleteTheme = prepareTheme(Tokens);
const learningHubTheme = CompleteTheme;
export default learningHubTheme;
//# sourceMappingURL=learningHubTheme.js.map